/**
 * Import libraries and ts-files.
 */

import { initGlobal } from './global';
import { initHeader } from './header';
import { initHero } from './hero';
import { initCategoryBlock } from './category-block';
import { initRecipePages } from './recipe-pages';
import { initSaveRecipes } from './save-recipes';
import { initRateRecipe } from './rate-recipe';
import { initProductPage } from './product-page';


/**
 * Initialize code.
 */
// TODO: Check if some components can be loaded only if they are needed, example CategoryBlock.
// Lisa have some function that we can use.

initGlobal();

// Components
initHeader();
initHero();

// Blocks
initCategoryBlock();

// Pages
initRecipePages();

// Save Recipes
initSaveRecipes();

// Rate Recipes
initRateRecipe();

// ProductPage
initProductPage();


